
define('text!modules/audiences/templates/audiences.html',[],function () { return '<div class="w-Audiences">\n  <div class="audiences-content"></div>\n</div>\n';});

